import { destroySocketConnection, initSocketConnection } from '@interhyp/platform-notification';
import { useEffect } from 'react';
import { useLocation } from 'react-use';

export function useFrontendNotifications(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const path =
      pathname === '/credit/' || pathname === '/credit/summary' || pathname === '/credit/documents'
        ? '/credit/api/frontend-notification'
        : '/api/frontend-notification';
    initSocketConnection(path);
    return () => {
      console.log('destroySocketConnection');
      destroySocketConnection();
    };
  }, [pathname]);
}
